import { ColorPickerField } from '../../components/ColorPickerField';
import slate from '../../packages/plugins/content/slate';

const defaultSlate = slate();

const jobSafetyPluginController: any = {
  Renderer: ({ children, data }: any) => (
    <div className="job-safety-block-outer">
      <div
        className="job-safety-block"
        style={{
          border: `4px solid ${
            data?.style?.borderColor
              ? data?.style?.borderColor
              : 'rgba(63, 81, 181, 1)'
          }`,
          margin: '5px 10px',
          padding: '10px 15px',
          fontSize: '20px',
          borderRadius: '16px',
          overflowWrap: 'anywhere',
          maxWidth: 300,
        }}
      >
        {children}
      </div>
    </div>
  ),
  createInitialChildren: () => {
    return [
      [
        {
          plugin: defaultSlate,
          data: defaultSlate.createData(({ plugins }) => ({
            children: [
              {
                plugin: plugins.headings.h4,
                children: ['Enter text'],
              },
            ],
          })),
        },
      ],
    ];
  },

  id: 'job-safety-plugin',
  title: 'Text Block Small',
  description: 'A simple block with a configurable border and text editor',
  version: 1,
  controls: [
    {
      title: 'Styling',
      controls: {
        type: 'autoform',
        schema: {
          type: 'object',
          required: [],
          properties: {
            style: {
              type: 'object',
              required: [],
              properties: {
                borderColor: {
                  type: 'string',
                  default: 'rgba(63, 81, 181, 1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Border Color: ',
                  },
                },
              },
            },
          },
        },
      },
    },
  ],
};

export default jobSafetyPluginController;
